import userInQueIcon from '../../../assets/images/icons/user-booking.svg'; // Adjust the path as necessary
import userQueIcon from '../../../assets/images/icons/user-in-join-queue.svg';
import loading from '../../../assets/images/icons/refreshloader.gif';

const CalendarLogicDesign = ({
  dateNumber,
  isSelected,
  bookingOnDate,
  currentDateString,
  handleCancelBookingClick,
  handleShowBookingModal,
  handleJoinQueueModal,
  handleLeaveQueueModal,
  fetchButton,
  zoneList,
  selectedZoneName,
  selectedCalendarZoneId,
  handleZoneChange,
  shouldShowFilter, // Boolean to control filter visibility
  filterIcon,       // Imported filter icon image
  creditInfo,       // creditInfo JSX received from parent
  recordsData,
  isPastDate,
  loadingDates,
  fetchWeekData
}) => {
  const isDateContentActive = !isPastDate;
  const dateDiv = isDateContentActive && dateNumber
    ? (<div className='ctm-date'>{dateNumber}</div>)
    : (<div className='past-date'>{dateNumber}</div>);

  const isLoading = loadingDates?.includes(currentDateString);

  let bookingIndicatorJSX = null;

  if (isLoading) {
    // show loading overlay for this date
    bookingIndicatorJSX = (
      <div className="ctm-refresh-button">
        <span style={{ color: 'green', fontWeight: 'bold' }}>
          <div id='cal-preloader'>
            <img src={loading} alt="Loading..." />
          </div>
        </span>
      </div>
    );
  } else if (isDateContentActive && bookingOnDate) {
    // User want to join in Booking Queue
    if (recordsData.QueueUser == 1 && bookingOnDate.DisplayQueue == 1) {
      bookingIndicatorJSX = (
        <div className='occupied-code'>
          <div
            style={{
              position: 'absolute',
              bottom: '0px',
              left: '8px',
              width: '38px',
              height: '38px',
              borderRadius: '100%',
              backgroundRepeat: 'repeat',
              backgroundPosition: 'center',
              backgroundaSize: 'contain',
              zIndex: 1,
            }}
            onClick={(event) => {
              event.stopPropagation();
              handleJoinQueueModal(currentDateString);
            }}
            disabled={isPastDate}
          >
            <img src={userQueIcon} alt="Booking Indicator" />
          </div>
        </div>
      );
    }
    //User in Booking Queue
    else if (recordsData.QueueUser == 1 && bookingOnDate.JoinedQueue == 1) {
      bookingIndicatorJSX = (
        <div className='occupied-code'>
          <div
            style={{
              position: 'absolute',
              bottom: '0px',
              left: '8px',
              width: '38px',
              height: '38px',
              borderRadius: '100%',
              backgroundRepeat: 'repeat',
              backgroundPosition: 'center',
              backgroundaSize: 'contain',
              zIndex: 1,
            }}
            onClick={(event) => {
              event.stopPropagation();
              handleLeaveQueueModal(currentDateString);
            }}
            disabled={isPastDate}
          >
            <img src={userInQueIcon} alt="Booking Indicator" />
          </div>
        </div>
      );
    }
    // Booked Spot
    else if (bookingOnDate.SpotId !== 0 && bookingOnDate.SpotName !== '0') {
      bookingIndicatorJSX = (
        <div
          className={`occupied-room ${isPastDate ? 'disabled-booking' : ''}`}
          onClick={(event) => {
            event.stopPropagation();
            if (!isPastDate) {
              handleCancelBookingClick(currentDateString);
            }
          }}
        >
          <div className="occupied-details">
            <div className="occupied-code">{bookingOnDate.SpotName}</div>
            <div className="occupied-credit">{bookingOnDate.TotalBookingCount}</div>
          </div>
        </div>
      );
    }
    //Space not available
    else if (bookingOnDate.IsBookingBlocked == 1 || bookingOnDate.CurrentMonth == 0) {
      bookingIndicatorJSX = (
        <div>
          <div className='occupied-room-space-not-available'>
            <div
              style={{
                position: 'absolute',
                top: '3px',
                right: '3px',
                width: '38px',
                height: '38px',
                borderRadius: '100%',
                backgroundColor: '#D2D2D2',
                backgroundRepeat: 'repeat',
                backgroundPosition: 'center',
                backgroundaSize: 'contain',
                zIndex: 0,
              }}
            />
          </div>
        </div>
      );
    }
    //Space available
    else if (
      bookingOnDate.CurrentMonth == 1 ||
      bookingOnDate.DeskAvailable == 1 ||
      bookingOnDate.MeetingRoomAvailable == 1 ||
      bookingOnDate.HourlySpotAvailable == 1
    ) {
      bookingIndicatorJSX = (
        <div>
          <div className='date-active'>
            <div
              style={{
                position: 'absolute',
                top: '3px',
                right: '3px',
                width: '38px',
                height: '38px',
                borderRadius: '100%',
                backgroundColor: '#1c988a3d',
                backgroundRepeat: 'repeat',
                backgroundPosition: 'center',
                backgroundaSize: 'contain',
                zIndex: 1,
              }}
              onClick={(event) => {
                event.stopPropagation();
                handleShowBookingModal(currentDateString);
              }}
              disabled={isPastDate}
            />
          </div>
        </div>
      );
    }
    //Space not available
    else if (
      bookingOnDate.DeskAvailable == 0 ||
      bookingOnDate.MeetingRoomAvailable == 0 ||
      bookingOnDate.HourlySpotAvailable == 0
    ) {
      bookingIndicatorJSX = (
        <div>
          <div className='occupied-room-space-not-available'>
            <div
              style={{
                position: 'absolute',
                top: '3px',
                right: '3px',
                width: '38px',
                height: '38px',
                borderRadius: '100%',
                backgroundColor: '#D2D2D2',
                backgroundRepeat: 'repeat',
                backgroundPosition: 'center',
                backgroundaSize: 'contain',
                zIndex: 0,
              }}
            />
          </div>
        </div>
      );
    } else {
      bookingIndicatorJSX = (
        <div>
          <div className='date-active'>
          </div>
        </div>
      );
    }
  }

  let containerClassName = 'fc-daygrid-day'; // Always include FullCalendar's base class

  // Only apply 'my-selected-day' if it's NOT a past date and it IS selected
  if (isDateContentActive && isSelected) {
    containerClassName += ' my-selected-day';
  }

  return (
    <div className={containerClassName}>
      <div className='date-active'>
        {bookingIndicatorJSX}
      </div>

      <div className={`fade-in ${isSelected ? 'my-selected-day-content' : ''}`}>
        {dateDiv}
        {fetchButton}
        {shouldShowFilter && (
          <div className="filter-elements-container" style={{
            position: 'absolute',
            top: '5px',
            right: '5px',
            display: 'flex',
            alignItems: 'center',
            gap: '5px'
          }}>
            <img
              src={filterIcon}
              alt="Filter"
              className="filter-icon"
              style={{
                width: '42px',
                height: 'auto',
                marginLeft: '9px',
                display: 'block'
              }}
            />
            <button
              type="button"
              className="filter-button"
              style={{
                width: '42px',
                marginLeft: '9px',
              }}
              // onClick={() => {
              //   console.log('Filter button clicked within CalendarLogicDesign!');
              // }}
            >
              Filter
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default CalendarLogicDesign;
